import { FC, useState, useEffect } from 'react';
import { Link } from 'react-router-dom';
import CloseRoundedIcon from '@mui/icons-material/CloseRounded';
import ContentCopyRoundedIcon from '@mui/icons-material/ContentCopyRounded';
import ForumOutlinedIcon from '@mui/icons-material/ForumOutlined';
import LabelOutlinedIcon from '@mui/icons-material/LabelOutlined';
import TaskAltRoundedIcon from '@mui/icons-material/TaskAltRounded';
import ReportProblemOutlinedIcon from '@mui/icons-material/ReportProblemOutlined';
import ImageOutlinedIcon from '@mui/icons-material/ImageOutlined';
import FormControl from '@mui/material/FormControl';
import Select from '@mui/material/Select';
import InputLabel from '@mui/material/InputLabel';
import { useTranslation } from 'react-i18next';
import { PageUrl } from '../../../types/enums';
import MenuItem from '@mui/material/MenuItem';
import { initialState, IProps } from './SCUIProductCommentDetailForm.config';
import { Box, Card, CardContent, Grid, Chip, TextField, Tooltip, Typography, IconButton } from '@mui/material';
import { SCUIButton, SCUIAutoCompleteInput, SCUILoading } from '../../atoms';
import Swal from 'sweetalert2';
import Fade from '@mui/material/Fade';
import LinearProgress from '@mui/material/LinearProgress';
import { CommentQuery } from '../../../services/query';
import './SCUIProductCommentDetailForm.scss';
import AuthService from '../../../services/auth/Auth.services';
import Helper from '../../../utils/helper';
import jwt_decode from 'jwt-decode';
import { enumCommentStatusFlowChipColor, enumCommentStatusFlowStatusTrName } from '../../../types/enums/status';
import { CommentCommand } from '../../../services/command';
import ProductCommentDetailCommentInfoRowV2 from './components/ProductCommentDetailCommentInfoRowV2';
import ProductCommentPhotoApprovalV2 from './components/ProductCommentPhotoApprovalV2';

export const SCUIProductCommentDetailFormV2: FC<IProps> = ({ id, history, onClose, rowData, setRowData }: any) => {
    const { t } = useTranslation();
    const [tagName, setTagName] = useState<any[]>([]);
    const [tagNames, setTagNames] = useState([]);
    const [displayedTags, setDisplayedTags] = useState([]);
    const [statusName, setStatusName] = useState('');
    const [commentUrl, setCommentUrl] = useState('');
    const [commentDetailInfo, setCommentDetailInfo] = useState<any>();
    const [phoneNumber, setPhoneNumber] = useState('');
    const [firstLastName, setFirstLastName] = useState('');
    const [userName, setUserName] = useState(' ');
    const [atananKisi, setAtananKisi] = useState(' ');
    const [commentDetail, setCommentDetail] = useState<any>(initialState.CommentDetailType);
    const [loading, setLoading] = useState(true);
    const [grievanceName, setGrievanceName] = useState('');
    const [grievanceDetail, setGrievanceDetail] = useState('');
    const [selectedPhotoModelList, setSelectedPhotoModelList] = useState<any>();
    const [approvalStatuses, setApprovalStatuses] = useState<{
        [key: string]: string;
    }>({});
    const [rejectionReasons, setRejectionReasons] = useState<any>({});
    const [rejectionReasonLookupList, setRejectionReasonLookupList] = useState<any>({});

    const sectionCardSx = {
        width: '100%',
        maxWidth: '100%',
        boxSizing: 'border-box',
        borderRadius: '24px',
        border: '1px solid rgba(15, 23, 42, 0.08)',
        boxShadow: '0 18px 40px rgba(15, 23, 42, 0.08)',
        background: 'linear-gradient(180deg, rgba(255,255,255,1) 0%, rgba(248,250,252,0.96) 100%)',
        overflow: 'hidden',
        transition: 'transform 0.25s ease, box-shadow 0.25s ease',
        '&:hover': {
            transform: 'translateY(-2px)',
            boxShadow: '0 22px 48px rgba(15, 23, 42, 0.12)',
        },
    } as const;

    const fieldWrapperSx = {
        p: 2,
        height: '100%',
        borderRadius: '18px',
        border: '1px solid rgba(148, 163, 184, 0.22)',
        backgroundColor: '#fff',
        boxShadow: '0 8px 24px rgba(15, 23, 42, 0.05)',
    } as const;

    const headerChipSx = {
        height: 40,
        fontWeight: 700,
        borderRadius: '999px',
        '& .MuiChip-label': {
            px: 1.75,
            fontSize: '0.95rem',
        },
    } as const;
    const copyToClipboard = async (value: any) => {
        if (value === null || value === undefined) return;
        try {
            await navigator.clipboard.writeText(String(value));
        } catch (error) {
            console.log('Copy failed :>> ', error);
        }
    };

    const authService = new AuthService();
    interface JwtPayload {
        preferred_username: string;
    }
    const commentId = history?.location?.state?.yorumId ? history?.location?.state?.yorumId : id;

    useEffect(() => {
        CommentQuery.RejectPhotoReasonList().then((res: any) => {
            setRejectionReasonLookupList(res);
        });
    }, []);

    useEffect(() => {
        GetCommentTicketList();
        getCommentDetail(commentId);

        getUserName();
    }, [history?.location?.state?.yorumId, id]);

    useEffect(() => {
        if (commentDetailInfo?.customerId) GetSingleCustomer();
    }, [commentDetailInfo?.customerId]);

    const GetSingleCustomer = async () => {
        try {
            let customerInfo: any = await CommentQuery.GetCustomer(commentDetailInfo?.customerId);
            setFirstLastName(
                customerInfo.data.customer
                    ? customerInfo.data.customer.firstName + ' ' + customerInfo.data.customer.lastName
                    : '-'
            );
            setPhoneNumber(customerInfo.data.customer ? customerInfo.data.customer.phoneNumber : '-');
        } catch (error) {
            console.log('Hata :>> ', error);
        }
    };
    const _handlChangeTag = (event: any, newValue: any) => {
        setDisplayedTags(newValue);
        setTagName(
            newValue.map(function (item: any) {
                return item.id;
            })
        );
    };

    useEffect(() => {
        setDisplayedTags(tagNames && tagNames.filter((item: any) => tagName?.includes(item.id)));
    }, [tagNames, tagName]);
    const getUserName = () => {
        authService.getUserInfo().then((getUserInfo: any) => {
            if (!Helper.isNil(getUserInfo)) {
                const decodedToken = jwt_decode<JwtPayload>(getUserInfo.access_token);
                setUserName(decodedToken.preferred_username.toLowerCase());
            }
        });
    };

    const other_link: any = import.meta.env.VITE_APPURL!;

    const _handleChangeStatus = (event: any) => {
        setStatusName(event.target.value as string);
    };
    const _handleChangeGrievence = (event: any) => {
        setGrievanceName(event.target.value as string);
        setGrievanceDetail('');
    };
    const _handleChangeGrievenceDetail = (event: any) => {
        setGrievanceDetail(event.target.value as string);
    };

    const GetCommentTicketList = async () => {
        try {
            let commentText: any = await CommentQuery.GetCommentTicketList();
            setTagNames(commentText.data);
        } catch (error) {
            console.log('Hata :>> ', error);
        }
    };

    const getCommentDetail = async (id: any): Promise<any> => {
        try {
            let params = { id: id };
            let commentInfo: any = await CommentQuery.GetCommentDataByIdV2(params);
            setCommentDetailInfo(commentInfo);
            setCommentDetail(commentInfo);
            setAtananKisi(commentInfo.userOperatorName);
            setStatusName(commentInfo.status);
            setCommentUrl(commentInfo.optionUrl);
            setGrievanceDetail(commentInfo.grievanceStatusText);
            setTagName(
                commentInfo.tag
                    ? commentInfo.tag
                          .split('_')
                          .filter((i: any) => i.length > 0)
                          .map(Number)
                    : []
            );
            setGrievanceName(commentInfo.grievanceStatus);
            setLoading((prevLoading) => !prevLoading);
        } catch (error) {
            console.info(error);
        }
    };
    const postAssignToMe = () => {
        let params = { rowId: Number(commentId), assignedOperator: atananKisi, status: commentDetail.status };
        CommentCommand.PostAssigToMeV2(params)
            .then((res: any) => {
                if (res?.isSuccess) {
                    const tempRowData = [...rowData];
                    const index = tempRowData.findIndex((row: any) => row.id === id);
                    tempRowData[index].operator = res?.operatorName?.toLowerCase();
                    setRowData(tempRowData);
                    Swal.fire({
                        icon: 'success',
                        title: t('general.completed'),
                        showConfirmButton: false,
                        timer: 1500,
                    });
                    setAtananKisi(userName);
                } else {
                    Swal.fire({
                        icon: 'error',
                        title: t('general.failed'),
                        showConfirmButton: false,
                        timer: 1500,
                    });
                }
            })
            .catch((error: any) => {
                Swal.fire({
                    icon: 'error',
                    title: t('general.failed'),
                    showConfirmButton: false,
                    timer: 1500,
                });
                console.log('Hata :>> ', error);
            });
    };

    const getParams = () => {
        let arr = tagName.map(String);
        let params: any = {};
        params.commentId = Number(commentId);
        params.operation = statusName.toString();
        params.grievanceStatus = grievanceName.toString();
        params.tickets = arr;
        params.grievanceStatusText = grievanceDetail;
        params.Images = selectedPhotoModelList;
        return params;
    };
    if (loading) {
        return <SCUILoading />;
    }
    const updateProductComment = () => {
        setLoading(true);
        let params: any = getParams();
        if (params.operation === '1') params.operation = '0';
        const photoStatusObj: any = [];
        for (const [key] of Object.entries(approvalStatuses)) {
            photoStatusObj.push({
                reasonId: key,
            });
        }
        const rejectedImagesWithoutReasons =
            !(params.Images === undefined || params.Images === null) &&
            params.Images.some((image: any) => image.Status === '3' && image.Reasons.length === 0);

        if (!(params.Images === undefined) && rejectedImagesWithoutReasons) {
            Swal.fire('Fotoğraf ret nedeni seçilmelidir.', '', 'error');
            setLoading(false);
            return;
        }
        if (params?.tickets?.length == 0) {
            Swal.fire('Etiket seçilmelidir.', '', 'error');
            setLoading(false);
            return;
        }
        if (params.operation == null || params.operation == '0') {
            Swal.fire(
                'Yorum metin içeriğinin Onaylandı veya Reddedildi olarak işaretlenmesi gerekmektedir.',
                '',
                'error'
            );
            setLoading(false);
            return;
        }
        CommentCommand.PostCommentStatusUpdateV2(params)
            .then((res: any) => {
                if (res.rejectMessage.visible)
                    Swal.fire({
                        icon: 'error',
                        title: res.rejectMessage.text,
                        showConfirmButton: false,
                        timer: 1500,
                    });
                if (res.assigntoMessage.visible)
                    Swal.fire({
                        icon: 'error',
                        title: res.assigntoMessage.text,
                        showConfirmButton: false,
                        timer: 1500,
                    });
                if (res.operationMessageStatus.visible)
                    Swal.fire({
                        icon: 'error',
                        title: res.operationMessageStatus.text,
                        showConfirmButton: false,
                        timer: 1500,
                    });

                if (res.operationMessage.visible) {
                    const tempRowData = [...rowData];
                    const index = tempRowData.findIndex((row: any) => row.id === id);
                    tempRowData.splice(index, 1);
                    setRowData(tempRowData);
                    Swal.fire({
                        icon: 'success',
                        title: res.operationMessage.text,
                        showConfirmButton: false,
                        timer: 1500,
                    });
                }
            })
            .catch((error: any) => {
                console.log('Hata :>> ', error);
            })
            .finally(() => {
                setLoading(false);
                onClose();
            });
    };
    return (
        commentDetailInfo && (
            <Grid className="commentDetailGrid">
                <Box>
                    <Fade in={loading} unmountOnExit>
                        <LinearProgress />
                    </Fade>
                </Box>
                <Box
                    sx={{
                        width: '100%',
                        maxWidth: '100%',
                        mx: 0,
                        mb: 4,
                        px: { xs: 1, sm: 1.5, md: 2 },
                        boxSizing: 'border-box',
                        overflowX: 'hidden',
                    }}
                >
                    <Card
                        sx={{
                            ...sectionCardSx,
                            mb: 3,
                            px: { xs: 2, md: 3 },
                            py: { xs: 2, md: 2.5 },
                        }}
                    >
                        <Grid container spacing={2} alignItems="center">
                            <Grid
                                size={{
                                    md: 8,
                                    xs: 10,
                                    lg: 8,
                                }}
                            >
                                <Box sx={{ display: 'flex', flexWrap: 'wrap', gap: 1.25, alignItems: 'center' }}>
                                    <Typography
                                        variant="h5"
                                        sx={{ fontWeight: 800, letterSpacing: '-0.02em', color: '#0f172a' }}
                                    >
                                        {t('commentDetail.header')}
                                    </Typography>
                                    <Box
                                        sx={{
                                            display: 'inline-flex',
                                            alignItems: 'center',
                                            gap: 0.5,
                                            pr: 0.5,
                                            borderRadius: '999px',
                                            backgroundColor: 'rgba(250, 175, 0, 0.14)',
                                            boxShadow: '0 8px 20px rgba(250, 175, 0, 0.12)',
                                        }}
                                    >
                                        <Chip
                                            label={`#${commentDetail?.id}`}
                                            sx={{
                                                ...headerChipSx,
                                                backgroundColor: 'transparent',
                                                color: '#c28100',
                                            }}
                                        />
                                        <Tooltip title="Kopyala">
                                            <IconButton
                                                size="small"
                                                onClick={() => copyToClipboard(commentDetail?.id)}
                                                sx={{
                                                    color: '#c28100',
                                                    mr: 0.25,
                                                    '&:hover': { backgroundColor: 'rgba(250, 175, 0, 0.12)' },
                                                }}
                                            >
                                                <ContentCopyRoundedIcon sx={{ fontSize: 18 }} />
                                            </IconButton>
                                        </Tooltip>
                                    </Box>
                                    <Chip
                                        label={enumCommentStatusFlowStatusTrName[statusName]}
                                        color={enumCommentStatusFlowChipColor[statusName]?.statusType}
                                        sx={{
                                            ...headerChipSx,
                                            boxShadow: '0 8px 20px rgba(15, 23, 42, 0.08)',
                                        }}
                                    />
                                </Box>
                            </Grid>
                            <Grid
                                size={{
                                    md: 4,
                                    xs: 2,
                                    lg: 4,
                                }}
                            >
                                <Box sx={{ display: 'flex', justifyContent: 'flex-end' }}>
                                    {window.location.href.indexOf('detail') > -1 ? (
                                        <Link to={PageUrl.commentList.url} className="linktxt">
                                            <IconButton
                                                sx={{
                                                    border: '1px solid rgba(148, 163, 184, 0.22)',
                                                    backgroundColor: '#fff',
                                                    boxShadow: '0 10px 25px rgba(15, 23, 42, 0.08)',
                                                    transition: 'all 0.2s ease',
                                                    '&:hover': {
                                                        transform: 'rotate(90deg)',
                                                        backgroundColor: '#f8fafc',
                                                    },
                                                }}
                                            >
                                                <CloseRoundedIcon />
                                            </IconButton>
                                        </Link>
                                    ) : (
                                        <IconButton
                                            onClick={onClose}
                                            sx={{
                                                border: '1px solid rgba(148, 163, 184, 0.22)',
                                                backgroundColor: '#fff',
                                                boxShadow: '0 10px 25px rgba(15, 23, 42, 0.08)',
                                                transition: 'all 0.2s ease',
                                                '&:hover': {
                                                    transform: 'rotate(90deg)',
                                                    backgroundColor: '#f8fafc',
                                                },
                                            }}
                                        >
                                            <CloseRoundedIcon />
                                        </IconButton>
                                    )}
                                </Box>
                            </Grid>
                        </Grid>
                    </Card>

                    <ProductCommentDetailCommentInfoRowV2
                        commentDetail={commentDetail}
                        commentUrl={commentUrl}
                        other_link={other_link}
                        phoneNumber={phoneNumber}
                        firstLastName={firstLastName}
                        atananKisi={atananKisi}
                        assignToMe={postAssignToMe}
                    />

                    <Card sx={{ ...sectionCardSx, mb: 3 }}>
                        <CardContent sx={{ p: { xs: 2.5, md: 3 } }}>
                            <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 2 }}>
                                <ForumOutlinedIcon sx={{ color: '#2563eb' }} />
                                <Typography variant="h6" sx={{ fontWeight: 800, color: '#0f172a' }}>
                                    {t('comments.comment')}
                                </Typography>
                                <Tooltip title={commentDetail.commentText || '-'}>
                                    <Chip
                                        label={`${commentDetail.commentText?.length || 0} karakter`}
                                        size="small"
                                        sx={{
                                            ml: 'auto',
                                            backgroundColor: 'rgba(37, 99, 235, 0.08)',
                                            color: '#1d4ed8',
                                            fontWeight: 700,
                                        }}
                                    />
                                </Tooltip>
                            </Box>
                            <div className="yorumDiv">{commentDetail.commentText}</div>
                        </CardContent>
                    </Card>

                    <Card sx={sectionCardSx}>
                        <CardContent sx={{ p: { xs: 2.5, md: 3 } }}>
                            <Grid container spacing={2.5}>
                                <Grid
                                    size={{
                                        xs: 12,
                                        md: 6,
                                        lg: 6,
                                    }}
                                    sx={{ minWidth: 0 }}
                                >
                                    <Box sx={fieldWrapperSx}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.5 }}>
                                            <LabelOutlinedIcon sx={{ color: '#7c3aed' }} />
                                            <Typography sx={{ fontWeight: 700, color: '#334155' }}>
                                                {t('general.tag')}
                                            </Typography>
                                        </Box>
                                        <FormControl fullWidth>
                                            {displayedTags && (
                                                <Tooltip
                                                    title={
                                                        displayedTags.length > 1 ? (
                                                            <ul style={{ margin: 0, padding: '0 0 0 20px' }}>
                                                                {displayedTags.map((tag: any, index) => (
                                                                    <li key={index}>{tag.keyWord}</li>
                                                                ))}
                                                            </ul>
                                                        ) : (
                                                            ''
                                                        )
                                                    }
                                                >
                                                    <div style={{ width: '100%' }}>
                                                        <SCUIAutoCompleteInput
                                                            defValue={displayedTags}
                                                            list={tagNames}
                                                            onChange={_handlChangeTag}
                                                            limitTags={1}
                                                            txtPlaceHolder={t('general.tag')}
                                                            searchValue="keyWord"
                                                        />
                                                    </div>
                                                </Tooltip>
                                            )}
                                        </FormControl>
                                    </Box>
                                </Grid>
                                <Grid
                                    size={{
                                        xs: 12,
                                        md: 3,
                                        lg: 3,
                                        xl: 3,
                                    }}
                                    sx={{ minWidth: 0 }}
                                >
                                    <Box sx={fieldWrapperSx}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.5 }}>
                                            <TaskAltRoundedIcon sx={{ color: '#16a34a' }} />
                                            <Typography sx={{ fontWeight: 700, color: '#334155' }}>
                                                {t('general.operation')}
                                            </Typography>
                                        </Box>
                                        <FormControl fullWidth>
                                            <InputLabel id="statusSelectLabel">{t('general.operation')}</InputLabel>
                                            <Select
                                                labelId="statusSelectLabel"
                                                fullWidth
                                                id="statusSelect"
                                                value={statusName}
                                                label="Durum"
                                                onChange={_handleChangeStatus}
                                            >
                                                <MenuItem value={2}>{t('general.approved')}</MenuItem>
                                                <MenuItem value={3}>{t('general.declined')}</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Box>
                                </Grid>

                                <Grid
                                    size={{
                                        xs: 12,
                                        md: 3,
                                        lg: 3,
                                        xl: 3,
                                    }}
                                    sx={{ minWidth: 0 }}
                                >
                                    <Box sx={fieldWrapperSx}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1.5 }}>
                                            <ReportProblemOutlinedIcon sx={{ color: '#ea580c' }} />
                                            <Typography sx={{ fontWeight: 700, color: '#334155' }}>
                                                {t('comments.grievance')}
                                            </Typography>
                                        </Box>
                                        <FormControl fullWidth>
                                            <InputLabel id="grievanceSelectLabel">{t('comments.grievance')}</InputLabel>
                                            <Select
                                                labelId="grievanceSelectLabel"
                                                id="grievanceSelect"
                                                value={grievanceName}
                                                label={t('comments.grievance')}
                                                onChange={_handleChangeGrievence}
                                            >
                                                <MenuItem value={1}>{t('general.var')}</MenuItem>
                                                <MenuItem value={0}>{t('general.giderildi')}</MenuItem>
                                            </Select>
                                        </FormControl>
                                    </Box>
                                </Grid>

                                {grievanceName == '1' && (
                                    <Grid
                                        size={{
                                            xs: 12,
                                            md: 12,
                                            lg: 12,
                                            xl: 12,
                                        }}
                                    >
                                        <Box sx={fieldWrapperSx}>
                                            <Typography sx={{ fontWeight: 700, color: '#334155', mb: 1.5 }}>
                                                {t('comments.grievanceDetail')}
                                            </Typography>
                                            <TextField
                                                label={t('comments.grievanceDetail')}
                                                defaultValue={grievanceDetail}
                                                variant="outlined"
                                                type="text"
                                                id="grievanceDetailText"
                                                fullWidth
                                                onChange={_handleChangeGrievenceDetail}
                                            />
                                        </Box>
                                    </Grid>
                                )}
                            </Grid>

                            {commentDetailInfo && commentDetailInfo.images && commentDetailInfo.images.length > 0 && (
                                <Card
                                    variant="outlined"
                                    sx={{
                                        mt: 3,
                                        borderRadius: '22px',
                                        borderColor: 'rgba(148, 163, 184, 0.2)',
                                        backgroundColor: 'rgba(248, 250, 252, 0.9)',
                                        boxShadow: 'inset 0 1px 0 rgba(255,255,255,0.8)',
                                    }}
                                >
                                    <CardContent sx={{ p: { xs: 2, md: 2.5 } }}>
                                        <Box sx={{ display: 'flex', alignItems: 'center', gap: 1, mb: 1 }}>
                                            <ImageOutlinedIcon sx={{ color: '#2563eb' }} />
                                            <Typography variant="h6" sx={{ fontWeight: 800, color: '#0f172a' }}>
                                                Fotoğraf Onayları
                                            </Typography>
                                            <Chip
                                                label={`${commentDetailInfo.images.length} görsel`}
                                                size="small"
                                                sx={{
                                                    ml: 'auto',
                                                    backgroundColor: 'rgba(37, 99, 235, 0.08)',
                                                    color: '#1d4ed8',
                                                    fontWeight: 700,
                                                }}
                                            />
                                        </Box>
                                        <ProductCommentPhotoApprovalV2
                                            photoModelList={commentDetailInfo?.images}
                                            selectedPhotoModelList={selectedPhotoModelList}
                                            setSelectedPhotoModelList={setSelectedPhotoModelList}
                                            approvalStatuses={approvalStatuses}
                                            setApprovalStatuses={setApprovalStatuses}
                                            rejectionReasons={rejectionReasons}
                                            setRejectionReasons={setRejectionReasons}
                                            rejectionReasonLookupList={rejectionReasonLookupList}
                                        ></ProductCommentPhotoApprovalV2>
                                    </CardContent>
                                </Card>
                            )}

                            <Grid
                                container
                                spacing={2}
                                justifyContent="space-between"
                                alignItems="center"
                                sx={{ mt: 3 }}
                                size={{
                                    md: 12,
                                    xs: 12,
                                    lg: 12,
                                }}
                            >
                                <Grid
                                    size={{
                                        lg: 6,
                                        md: 6,
                                        xs: 12,
                                    }}
                                >
                                    <Box sx={{ display: 'flex', justifyContent: { xs: 'stretch', md: 'flex-start' } }}>
                                        <Box sx={{ minWidth: { xs: '100%', sm: 180, md: 180 } }}>
                                            <SCUIButton
                                                text={t('general.assignToMe')}
                                                type="primary"
                                                sizeType="fixed"
                                                size={'m'}
                                                buttonType="button"
                                                onClick={postAssignToMe}
                                            />
                                        </Box>
                                    </Box>
                                </Grid>
                                <Grid
                                    size={{
                                        lg: 6,
                                        md: 6,
                                        xs: 12,
                                    }}
                                >
                                    <Box
                                        sx={{
                                            display: 'flex',
                                            justifyContent: { xs: 'stretch', md: 'flex-end' },
                                            gap: 1.5,
                                            flexWrap: 'wrap',
                                        }}
                                    >
                                        <Box sx={{ minWidth: { xs: '100%', sm: 180, md: 180 } }}>
                                            <SCUIButton
                                                text={t('general.complete')}
                                                type="primary"
                                                sizeType="fixed"
                                                size={'m'}
                                                buttonType="button"
                                                onClick={updateProductComment}
                                            />
                                        </Box>
                                    </Box>
                                </Grid>
                            </Grid>
                        </CardContent>
                    </Card>
                </Box>
            </Grid>
        )
    );
};
